/* eslint-disable */
import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
// import Build from "@material-ui/icons/Build";
// import Subject from "@material-ui/icons/Subject";
// import FormatPaint from "@material-ui/icons/FormatPaint";
// import Code from "@material-ui/icons/Code";
// import Dashboard from "@material-ui/icons/Dashboard";
// import Timeline from "@material-ui/icons/Timeline";
// import Group from "@material-ui/icons/Group";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
// import CardHeader from "components/Card/CardHeader.jsx";
import Button from "components/CustomButtons/Button.jsx";
// import Muted from "components/Typography/Muted.jsx";
// import InfoArea from "components/InfoArea/InfoArea.jsx";
// import Badge from "components/Badge/Badge.jsx";

import projectsStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/projectsStyle.jsx";

import image01 from "assets/img/examples/image-01-full.jpg";
import image02 from "assets/img/examples/image-02-full.jpg";
import image03 from "assets/img/examples/image-03-full.jpg";
// import image04 from "assets/img/examples/image-04-full.jpg";
// import image05 from "assets/img/examples/image-05-full.jpg";
import image06 from "assets/img/examples/image-06-full.jpg";
// import image07 from "assets/img/examples/image-07-full.jpg";
import image08 from "assets/img/examples/image-08-full.jpg";
import image09 from "assets/img/examples/image-09-full.jpg";
import image10 from "assets/img/examples/image-10-full.jpg";
// import image11 from "assets/img/examples/image-11-full.jpg";
import image12 from "assets/img/examples/image-12-full.jpg";
import image13 from "assets/img/examples/image-13-full.jpg";
import image14 from "assets/img/examples/image-14-full.jpg";
import image15 from "assets/img/examples/image-15-full.jpg";
// import image16 from "assets/img/examples/image-16-full.jpg";
import image17 from "assets/img/examples/image-17-full.jpg";
import image18 from "assets/img/examples/drm_video_system_p.jpg";
import image19 from "assets/img/examples/point_system_p.jpg";
import image20 from "assets/img/examples/onetime_password_system_p.jpg";
import image21 from "assets/img/examples/message_board_system_p.jpg";

import image22 from "assets/img/examples/original_blockchain_system_p.jpg";
import image23 from "assets/img/examples/smart_contract_system_p.jpg";
import bigdataImage from "assets/img/examples/bigdata_analysis_p.jpg";

// import cardBlog3 from "assets/img/examples/card-blog3.jpg";
// import cardProject1 from "assets/img/examples/card-project1.jpg";
// import cardProject2 from "assets/img/examples/card-project2.jpg";
// import cardProject3 from "assets/img/examples/card-project3.jpg";
// import cardProject4 from "assets/img/examples/card-project4.jpg";
// import cardProject5 from "assets/img/examples/card-project5.jpg";
// import cardProject6 from "assets/img/examples/card-project6.jpg";

function SectionProjects({ ...props }) {
  const { classes, ...rest } = props;
  return (
    <div className="cd-section" {...rest}>
      {/* Project 1 START */}
      <div className={classes.projects}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={8}
              md={8}
              className={`${classes.mlAuto} ${classes.mrAuto} ${
                classes.textCenter
              }`}
            >
              <a href="/blockChain/download.html" onClick={e => { }}>
                <h2 className={classes.title}>
                  ブロックチェーンでベーシックインカムを実現する。
                </h2>
              </a>
              <h3>
                ## 私たちのゴール ##
              </h3>
              <h4>
                中央銀行／政府／企業が発行したお金（硬貨、紙幣、クレジット、デビッド、プリペイド）の代わりに、システム（言い換えれば、自律インテリジェンス）によって発行されるポイント* で生活する社会をめざします。
                <br></br>
                このポイントは中央銀行や政府が発行する通貨と兌換（双方向に交換／譲渡／売買／貸借）できません。
              </h4>
              <h6>
                *ブロックチェーンで管理されるポイント
              </h6>
              <br></br>
              <h4>
                このシステムを管理するスーパーユーザや管理者は存在しません。言い換えれば、参加者全員で管理するのです。
              </h4>
              <h4>
                ブロックチェーンで管理されるポイントはモノやサービスのやり取りに使われます。
              </h4>
              <h4>
                このポイントを得るために働く必要はありません。
              </h4>
              <h4>
                要求に応じて、毎月ポイントが発行されます。  
              </h4>
              <h3>
              ## Our Goals ##
              </h3>
            <h4>
              In Our Goaled Community, Use Blockchained Points issued by the SYSTEM(in other words Autonomous Intelligence) instead of Money issued by CentralBank/Fed./Gov./Co. (Coin/Bill/Credit/Debit/Prepaid).
            </h4>
            <h4>
              Blockchained Points is for exchange Goods/Services.
            </h4>
            <h4>
              Must NOT any Working for get the Points.
            </h4>
            <h4>
              Get the Points every month on demand.  
            </h4>
              <br></br>
              <a href="/blockChain/download.html" onClick={e => { }}>
              <h4>
                ブロックチェーン・ライブラリー・スイート公開中 (iOS/Linux対応、Swift Package/Swift Static Linux SDK に対応)
              </h4>
              </a>
              <h4>
                2024年7月9日できあがりました。2025年3月18日Linuxに対応しました。
              </h4>
              <h4>
                All Features Done in 20240709 JST. Applied to Linux in 20250318 JST.
              </h4>
              <a href="https://github.com/webbananaunite/" onClick={e => { }}>
              <h4>
                Blockchain Library Suite in Publishing (Compatible with iOS/Linux on Swift Package/Swift Static Linux SDK)
              </h4>
              </a>
              <NavPills
                alignCenter
                color="primary"
                tabs={[
                  { tabButton: "すべて", tabContent: (
                    <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image14})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/ipad/sip_webrtc.htm" onClick={e => { }}>
                            <h3 className={classes.cardTitleWhite}>
                              オンライン診療・ビデオ通話
                          </h3>
                          </a>
                          <dl className={classes.cardDescription}>
                            <dd>*Fitbitを装着した患者の脈拍をリアルタイムに確認！</dd>
                            <dd>*ビデオ映像だけではなく、テキストや画像も同時にやりとり！</dd>
                          </dl>
                          <Button round color="danger"
                            href="/ipad/sip_webrtc.htm"
                            onClick={e => { }}
                          >
                            <Icon>exit_to_app</Icon> View App
                        </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${bigdataImage})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web</h6>
                          <a href="/web/bigdata_analysis_system.html" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                            Google Cloud Spannerを活用したビッグデータ解析
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          10億オーダーのビッグデータを位置情報ハッシュにより統計解析。Google Cloud Platform Cloud Spannerを活用した。
                          </p>
                          <Button round color="danger"
                            href="/web/bigdata_analysis_system.html"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image22})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/blockChain/original_blockchain_system.html" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                            オリジナル・ブロックチェーン構築
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          オリジナルのブロックチェーンを構築し、ユーザ認証不要かつデータ改変不可能なシステムを構築。
                          </p>
                          <Button round color="danger"
                            href="/blockChain/original_blockchain_system.html"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image23})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/blockChain/smart_contract_system.html" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                            動産・不動産・ソフトウェア・労働力のシェアリングエコノミー・システム
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          イーサリアムのブロックチェーンを活用し、動産・不動産、そして労働力・ソフトウェアまでを共有する際の信頼・安全を暗号技術によって担保したシステム。
                          </p>
                          <Button round color="danger"
                            href="/blockChain/smart_contract_system.html"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image19})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/web/point_system.html" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                              ポイントシステム
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          バックエンドのポイントシステムとスマホ決済でも使用されているQRコードにより、ポイント獲得や使用を可能としました。
                          </p>
                          <Button round color="danger"
                            href="/web/point_system.html"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image18})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/web/drm_video_system.html" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                              ビデオ動画デジタル著作権管理システム(DRMシステム)
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          暗号技術を活用し、認証やコンテンツ復号鍵を再暗号化することでコンテンツを安全に保全できます。
                          </p>
                          <Button round color="danger"
                            href="/web/drm_video_system.html"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image20})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/web/onetime_password_system.html" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                              ワンタイムパスワード・システム
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          銀行取引システムでトークンとして採用されているハッシュ技術を活用し、パスワード保護だけでは不十分であったセキュリティ保護を実現しました。
                          </p>
                          <Button round color="danger"
                            href="/web/onetime_password_system.html"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image21})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/web/message_board_system.html" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                              メッセージボード・システム
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          掲示板やチャットとして知られているテキスト・メッセージを簡易でありながら、セキュアにやり取りすることを両立したシステム。
                          </p>
                          <Button round color="danger"
                            href="/web/message_board_system.html"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image06})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/smartContract.html" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                              スマートコントラクト(Ethereum Ðapp)
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          ブロックチェーンP2Pネットワークを用いたスマートコントラクトEthereum Ðappでサーバ管理が必要ないシェアリングエコノミー・エスクロー（預託）・公正取引・著作権ライセンス管理をEthereum Ðappにより実現します。
                          </p>
                          <Button round color="danger"
                            href="/smartContract.html"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image09})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/ipad/GoodNightOnYouTube.htm" onClick={e => e.preventDefault()}>
                            <h3 className={classes.cardTitleWhite}>
                              萌えキュン時計
                            </h3>
                          </a>
                          <dl className={classes.cardDescription}>
                            <dd>音声認識エンジンでiPhoneと会話できる！</dd>
                            <dd>YouTube動画の連続再生やキッチンタイマー機能も！</dd>
                          </dl>
                          <Button round color="danger"
                            href="/ipad/GoodNightOnYouTube.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image01})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>iOS/Android</h6>
                          <a href="/ipad/ipad-music-appli.htm" onClick={e => e.preventDefault()}>
                            <h3 className={classes.cardTitleWhite}>
                              25Beans
                            </h3>
                          </a>
                          <dl className={classes.cardDescription}>
                            <dd>16面体で描かれた小豆がスマホ画面を縦横無尽に動き回る3Dシミュレーションゲーム！</dd>
                            <dd>スマホの中に25個の小豆が入っているような新感覚ゲーム！</dd>
                          </dl>
                          <Button round color="danger"
                            href="/ipad/ipad-music-appli.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image08})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>iOS</h6>
                          <a href="/ipad/" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                            システム手帳
                            </h3>
                          </a>
                          <dl className={classes.cardDescription}>
                            <dd>iPadで手書きメモを取ることがこんなにも快適なんて！</dd>
                            <dd>スケジュール帳がiCloud自動同期で、iPhoneとiPadで同じデータが見れちゃう！</dd>
                          </dl>
                          <Button round color="danger"
                            href="/ipad/"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image10})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web</h6>
                          <a href="/gyomunaiyo/" onClick={e => e.preventDefault()}>
                            <h3 className={classes.cardTitleWhite}>
                            レスポンシブ・デザイン
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          ホームページにレスポンシブ・デザインを採用することでスマホやiPhoneからも同じコンテンツを見やすいデザインでプレゼンテーションできます。
                          </p>
                          <Button round color="danger"
                            href="/gyomunaiyo/"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image15})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/ipad/health_check.htm" onClick={e => e.preventDefault()}>
                            <h3 className={classes.cardTitleWhite}>
                            Fitbit健康管理
                            </h3>
                          </a>
                          {/* <p className={classes.cardDescription}> */}
                          <dl className={classes.cardDescription}>
                            <dd>*健康管理記録を保存しグラフ表示によって分かりやすく解析！</dd>
                            <dd>*地図と連動させることでウォーキングコースを地図上にマッピング表示！</dd>
                          </dl>
                          {/* </p> */}
                          <Button round color="danger"
                            href="/ipad/health_check.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image12})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>iOS/Android</h6>
                          <a href="/ipad/camera.htm" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                            カメラ画像加工
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          写真をビデオに変換したり、ビデオから写真を抜き出したりすることができます！
                          </p>
                          <Button round color="danger"
                            href="/ipad/camera.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image02})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>iOS/Android</h6>
                          <a href="/ipad/eigyo_tool_app.htm" onClick={e => e.preventDefault()}>
                            <h3 className={classes.cardTitleWhite}>
                            iPadタブレット営業ツール
                            </h3>
                          </a>
                          <dl className={classes.cardDescription}>
                            <dd>クラウドと連携していつでも最新の営業データに！</dd>
                            <dd>ネイティブアプリの豊かな表現力！</dd>
                          </dl>
                          <Button round color="danger"
                            href="/ipad/eigyo_tool_app.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image03})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/ipad/publicity_app.htm" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                            SNS＋宣伝広告
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          SNSと連携したゲームで友達や職場で話題をシェア！<br/>
                          アプリケーションとツイッターやフェイスブックなどのSNSサービスを活用！
                          </p>
                          <Button round color="danger"
                            href="/ipad/publicity_app.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image17})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>iOS/Android</h6>
                          <a href="/ipad/speech_recognition.htm" onClick={e => e.preventDefault()}>
                            <h3 className={classes.cardTitleWhite}>
                            音声認識／自動翻訳
                            </h3>
                          </a>
                          <dl className={classes.cardDescription}>
                            <dd>*スマホに話しかけると、相手の国の言葉に自動翻訳！</dd>
                            <dd>*語学学習にも活用できる！</dd>
                          </dl>
                          <Button round color="danger"
                            href="/ipad/speech_recognition.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image12})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>iOS/Android</h6>
                          <a href="/ipad/video_picture_app.htm" onClick={e => e.preventDefault()}>
                            <h3 className={classes.cardTitleWhite}>
                            動画写真＋GSP地図情報
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          GPS情報で地図上にマッピング！<br/>
                          動画や写真はスマホととても好相性！
                          </p>
                          <Button round color="danger"
                            href="/ipad/video_picture_app.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image13})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web</h6>
                          <a href="/software/sk_kokyaku_kanri_cloud.htm" onClick={e => e.preventDefault()}>
                            <h3 className={classes.cardTitleWhite}>
                            顧客管理クラウド
                            </h3>
                          </a>
                          {/* <p className={classes.cardDescription}> */}
                          <dl className={classes.cardDescription}>
                            <dd>大規模システム対応！</dd><dd>引き合い／受注管理</dd>
                            <dd>◆統計情報</dd>
                            <dd>◆ドキュメント管理</dd>
                            <dd>◆Eメール管理</dd>
                          </dl>
                          {/* </p> */}
                          <Button round color="danger"
                            href="/software/sk_kokyaku_kanri_cloud.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                  </GridContainer>
                          ) },
                  { tabButton: "ビジネス", tabContent: (
                    <GridContainer>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image08})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>iOS</h6>
                          <a href="/ipad/" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                            システム手帳
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          iPadで手書きメモを取ることがこんなにも快適なんて！
                          スケジュール帳がiCloud自動同期で、iPhoneとiPadで同じデータが見れちゃう！
                          </p>
                          <Button round color="danger"
                            href="/ipad/"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                    <Card
                      raised
                      background
                      style={{ backgroundImage: `url(${image14})` }}>
                      <CardBody background>
                        <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                        <a href="/ipad/sip_webrtc.htm" onClick={e => {}}>
                          <h3 className={classes.cardTitleWhite}>
                          遠隔診療・ビデオ通話
                          </h3>
                        </a>
                        <dl className={classes.cardDescription}>
                          <dd>*Fitbitを装着した患者の脈拍をリアルタイムに確認！</dd>
                          <dd>*ビデオ映像だけではなく、テキストや画像も同時にやりとり！</dd>
                        </dl>
                        <Button round color="danger"
                          href="/ipad/sip_webrtc.htm"
                          onClick={e => {}}>
                          <Icon>exit_to_app</Icon> View App
                        </Button>
                      </CardBody>
                    </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image02})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>iOS/Android</h6>
                          <a href="/ipad/eigyo_tool_app.htm" onClick={e => e.preventDefault()}>
                            <h3 className={classes.cardTitleWhite}>
                            iPadタブレット営業ツール
                            </h3>
                          </a>
                          <dl className={classes.cardDescription}>
                            <dd>クラウドと連携していつでも最新の営業データに！</dd>
                            <dd>ネイティブアプリの豊かな表現力！</dd>
                          </dl>
                          <Button round color="danger"
                            href="/ipad/eigyo_tool_app.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image17})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>iOS/Android</h6>
                          <a href="/ipad/speech_recognition.htm" onClick={e => e.preventDefault()}>
                            <h3 className={classes.cardTitleWhite}>
                            音声認識／自動翻訳
                            </h3>
                          </a>
                          <dl className={classes.cardDescription}>
                            <dd>*スマホに話しかけると、相手の国の言葉に自動翻訳！</dd>
                            <dd>*語学学習にも活用できる！</dd>
                          </dl>
                          <Button round color="danger"
                            href="/ipad/speech_recognition.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image12})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>iOS/Android</h6>
                          <a href="/ipad/video_picture_app.htm" onClick={e => e.preventDefault()}>
                            <h3 className={classes.cardTitleWhite}>
                            動画写真＋GSP地図情報
                            </h3>
                          </a>
                          <dl className={classes.cardDescription}>
                            <dd>GPS情報で地図上にマッピング！</dd>
                            <dd>動画や写真はスマホととても好相性！</dd>
                          </dl>
                          <Button round color="danger"
                            href="/ipad/video_picture_app.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image13})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web</h6>
                          <a href="/software/sk_kokyaku_kanri_cloud.htm" onClick={e => e.preventDefault()}>
                            <h3 className={classes.cardTitleWhite}>
                            顧客管理クラウド
                            </h3>
                          </a>
                          {/* <p className={classes.cardDescription}> */}
                          <dl className={classes.cardDescription}>
                            <dd>大規模システム対応！</dd><dd>引き合い／受注管理</dd>
                            <dd>◆統計情報</dd>
                            <dd>◆ドキュメント管理</dd>
                            <dd>◆Eメール管理</dd>
                          </dl>
                          {/* </p> */}
                          <Button round color="danger"
                            href="/software/sk_kokyaku_kanri_cloud.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    </GridContainer>
                  ) },
                  { tabButton: "パブリシティ", tabContent: (
                    <GridContainer>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image09})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/ipad/GoodNightOnYouTube.htm" onClick={e => e.preventDefault()}>
                            <h3 className={classes.cardTitleWhite}>
                              萌えキュン時計
                            </h3>
                          </a>
                          <dl className={classes.cardDescription}>
                            <dd>音声認識エンジンでiPhoneと会話できる！</dd>
                            <dd>YouTube動画の連続再生やキッチンタイマー機能も！</dd>
                          </dl>
                          <Button round color="danger"
                            href="/ipad/GoodNightOnYouTube.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                    <Card
                      raised
                      background
                      style={{ backgroundImage: `url(${image03})` }}
                    >
                      <CardBody background>
                        <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                        <a href="/ipad/publicity_app.htm" onClick={e => {}}>
                          <h3 className={classes.cardTitleWhite}>
                          SNS＋宣伝広告
                          </h3>
                        </a>
                        <dl className={classes.cardDescription}>
                          <dd>SNSと連携したゲームで友達や職場で話題をシェア！</dd>
                          <dd>スマートフォンアプリとツイッターやフェイスブックなどのSNSサービスを活用！</dd>
                        </dl>
                        <Button round color="danger"
                          href="/ipad/publicity_app.htm"
                          onClick={e => {}}
                        >
                          <Icon>exit_to_app</Icon> View App
                        </Button>
                      </CardBody>
                    </Card>
                  </GridItem>
                  </GridContainer>
                  ) },
                  { tabButton: "ゲーム", tabContent: (
                    <GridContainer>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image01})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>iOS/Android</h6>
                          <a href="/ipad/ipad-music-appli.htm" onClick={e => e.preventDefault()}>
                            <h3 className={classes.cardTitleWhite}>
                              25Beans
                            </h3>
                          </a>
                          <dl className={classes.cardDescription}>
                            <dd>16面体で描かれた小豆がスマホ画面を縦横無尽に動き回る3Dシミュレーションゲーム！</dd>
                            <dd>スマホの中に25個の小豆が入っているような新感覚ゲーム！</dd>
                          </dl>
                          <Button round color="danger"
                            href="/ipad/ipad-music-appli.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                    <Card
                      raised
                      background
                      style={{ backgroundImage: `url(${image03})` }}
                    >
                      <CardBody background>
                        <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                        <a href="/ipad/publicity_app.htm" onClick={e => {}}>
                          <h3 className={classes.cardTitleWhite}>
                          SNS＋宣伝広告
                          </h3>
                        </a>
                        <dl className={classes.cardDescription}>
                          <dd>SNSと連携したゲームで友達や職場で話題をシェア！</dd>
                          <dd>スマートフォンアプリとツイッターやフェイスブックなどのSNSサービスを活用！</dd>
                        </dl>
                        <Button round color="danger"
                          href="/ipad/publicity_app.htm"
                          onClick={e => {}}
                        >
                          <Icon>exit_to_app</Icon> View App
                        </Button>
                      </CardBody>
                    </Card>
                  </GridItem>
                  </GridContainer>
                    ) },
                  { tabButton: "ツール", tabContent: (
                    <GridContainer>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image08})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>iOS</h6>
                          <a href="/ipad/" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                            システム手帳
                            </h3>
                          </a>
                          <dl className={classes.cardDescription}>
                            <dd>iPadで手書きメモを取ることがこんなにも快適なんて！</dd>
                            <dd>スケジュール帳がiCloud自動同期で、iPhoneとiPadで同じデータが見れちゃう！</dd>
                          </dl>
                          <Button round color="danger"
                            href="/ipad/"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image14})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/ipad/sip_webrtc.htm" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                            遠隔診療・ビデオ通話
                            </h3>
                          </a>
                          {/* <p className={classes.cardDescription}> */}
                          <dl className={classes.cardDescription}>
                            <dd>*Fitbitを装着した患者の脈拍をリアルタイムに確認！</dd>
                            <dd>*ビデオ映像だけではなく、テキストや画像も同時にやりとり！</dd>
                          </dl>
                          {/* </p> */}
                          <Button round color="danger"
                            href="/ipad/sip_webrtc.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image12})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>iOS/Android</h6>
                          <a href="/ipad/camera.htm" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                            カメラ画像加工
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          写真をビデオに変換したり、ビデオから写真を抜き出したりすることができます！
                          </p>
                          <Button round color="danger"
                            href="/ipad/camera.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image17})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>iOS/Android</h6>
                          <a href="/ipad/speech_recognition.htm" onClick={e => e.preventDefault()}>
                            <h3 className={classes.cardTitleWhite}>
                            音声認識／自動翻訳
                            </h3>
                          </a>
                          <dl className={classes.cardDescription}>
                            <dd>*スマホに話しかけると、相手の国の言葉に自動翻訳！</dd>
                            <dd>*語学学習にも活用できる！</dd>
                          </dl>
                          <Button round color="danger"
                            href="/ipad/speech_recognition.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image12})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>iOS/Android</h6>
                          <a href="/ipad/video_picture_app.htm" onClick={e => e.preventDefault()}>
                            <h3 className={classes.cardTitleWhite}>
                            動画写真＋GSP地図情報
                            </h3>
                          </a>
                          <dl className={classes.cardDescription}>
                            <dd>GPS情報で地図上にマッピング！</dd>
                            <dd>動画や写真はスマホととても好相性！</dd>
                          </dl>
                          <Button round color="danger"
                            href="/ipad/video_picture_app.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    </GridContainer>
                  ) },
                  { tabButton: "クラウド", tabContent: (
                    <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${bigdataImage})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web</h6>
                          <a href="/web/bigdata_analysis_system.html" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                            Google Cloud Spannerを活用したビッグデータ解析
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          10億オーダーのビッグデータを位置情報ハッシュにより統計解析。Google Cloud Platform Cloud Spannerを活用した。
                          </p>
                          <Button round color="danger"
                            href="/web/bigdata_analysis_system.html"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image19})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/web/point_system.html" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                              ポイントシステム
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          バックエンドのポイントシステムとスマホ決済でも使用されているQRコードにより、ポイント獲得や使用を可能としました。
                          </p>
                          <Button round color="danger"
                            href="/web/point_system.html"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image20})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/web/onetime_password_system.html" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                              ワンタイムパスワード・システム
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          銀行取引システムでトークンとして採用されているハッシュ技術を活用し、パスワード保護だけでは不十分であったセキュリティ保護を実現しました。
                          </p>
                          <Button round color="danger"
                            href="/web/onetime_password_system.html"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image21})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/web/message_board_system.html" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                              メッセージボード・システム
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          掲示板やチャットとして知られているテキスト・メッセージを簡易でありながら、セキュアにやり取りすることを両立したシステム。
                          </p>
                          <Button round color="danger"
                            href="/web/message_board_system.html"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image18})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/web/drm_video_system.html" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                              ビデオ動画デジタル著作権管理システム(DRMシステム)
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          暗号技術を活用し、認証やコンテンツ復号鍵を再暗号化することでコンテンツを安全に保全できます。
                          </p>
                          <Button round color="danger"
                            href="/web/drm_video_system.html"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image15})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/ipad/health_check.htm" onClick={e => e.preventDefault()}>
                            <h3 className={classes.cardTitleWhite}>
                            Fitbit健康管理
                            </h3>
                          </a>
                          {/* <p className={classes.cardDescription}> */}
                          <dl className={classes.cardDescription}>
                            <dd>*健康管理記録を保存しグラフ表示によって分かりやすく解析！</dd>
                            <dd>*地図と連動させることでウォーキングコースを地図上にマッピング表示！</dd>
                          </dl>
                          {/* </p> */}
                          <Button round color="danger"
                            href="/ipad/health_check.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image02})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>iOS/Android</h6>
                          <a href="/ipad/eigyo_tool_app.htm" onClick={e => e.preventDefault()}>
                            <h3 className={classes.cardTitleWhite}>
                            iPadタブレット営業ツール
                            </h3>
                          </a>
                          <dl className={classes.cardDescription}>
                            <dd>クラウドと連携していつでも最新の営業データに！</dd>
                            <dd>ネイティブアプリの豊かな表現力！</dd>
                          </dl>
                          <Button round color="danger"
                            href="/ipad/eigyo_tool_app.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image12})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>iOS/Android</h6>
                          <a href="/ipad/video_picture_app.htm" onClick={e => e.preventDefault()}>
                            <h3 className={classes.cardTitleWhite}>
                            動画写真＋GSP地図情報
                            </h3>
                          </a>
                          <dl className={classes.cardDescription}>
                            <dd>GPS情報で地図上にマッピング！</dd>
                            <dd>動画や写真はスマホととても好相性！</dd>
                          </dl>
                          <Button round color="danger"
                            href="/ipad/video_picture_app.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image13})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web</h6>
                          <a href="/software/sk_kokyaku_kanri_cloud.htm" onClick={e => e.preventDefault()}>
                            <h3 className={classes.cardTitleWhite}>
                            顧客管理クラウド
                            </h3>
                          </a>
                          {/* <p className={classes.cardDescription}> */}
                          <dl className={classes.cardDescription}>
                            <dd>大規模システム対応！</dd><dd>引き合い／受注管理</dd>
                            <dd>◆統計情報</dd>
                            <dd>◆ドキュメント管理</dd>
                            <dd>◆Eメール管理</dd>
                          </dl>
                          {/* </p> */}
                          <Button round color="danger"
                            href="/software/sk_kokyaku_kanri_cloud.htm"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    </GridContainer>
                  ) },
                  { tabButton: "ブロックチェーン｜暗号技術", tabContent: (
                    <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image18})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/web/drm_video_system.html" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                              ビデオ動画デジタル著作権管理システム(DRMシステム)
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          暗号技術を活用し、認証やコンテンツ復号鍵を再暗号化することでコンテンツを安全に保全できます。
                          </p>
                          <Button round color="danger"
                            href="/web/drm_video_system.html"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image22})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/blockChain/original_blockchain_system.html" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                            オリジナル・ブロックチェーン構築
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          オリジナルのブロックチェーンを構築し、ユーザ認証不要かつデータ改変不可能なシステムを構築。
                          </p>
                          <Button round color="danger"
                            href="/blockChain/original_blockchain_system.html"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image23})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/blockChain/smart_contract_system.html" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                            動産・不動産・ソフトウェア・労働力のシェアリングエコノミー・システム
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          イーサリアムのブロックチェーンを活用し、動産・不動産、そして労働力・ソフトウェアまでを共有する際の信頼・安全を暗号技術によって担保したシステム。
                          </p>
                          <Button round color="danger"
                            href="/blockChain/smart_contract_system.html"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image19})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/web/point_system.html" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                              ポイントシステム
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          バックエンドのポイントシステムとスマホ決済でも使用されているQRコードにより、ポイント獲得や使用を可能としました。
                          </p>
                          <Button round color="danger"
                            href="/web/point_system.html"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image20})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/web/onetime_password_system.html" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                              ワンタイムパスワード・システム
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          銀行取引システムでトークンとして採用されているハッシュ技術を活用し、パスワード保護だけでは不十分であったセキュリティ保護を実現しました。
                          </p>
                          <Button round color="danger"
                            href="/web/onetime_password_system.html"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image21})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/web/message_board_system.html" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                              メッセージボード・システム
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          掲示板やチャットとして知られているテキスト・メッセージを簡易でありながら、セキュアにやり取りすることを両立したシステム。
                          </p>
                          <Button round color="danger"
                            href="/web/message_board_system.html"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <Card
                        raised
                        background
                        style={{ backgroundImage: `url(${image06})` }}
                      >
                        <CardBody background>
                          <h6 className={classes.cardCategory}>Web/iOS/Android</h6>
                          <a href="/smartContract.html" onClick={e => {}}>
                            <h3 className={classes.cardTitleWhite}>
                              スマートコントラクト(Ethereum Ðapp)
                            </h3>
                          </a>
                          <p className={classes.cardDescription}>
                          ブロックチェーンP2Pネットワークを用いたスマートコントラクトEthereum Ðappでサーバ管理が必要ないシェアリングエコノミー・エスクロー（預託）・公正取引・著作権ライセンス管理をEthereum Ðappにより実現します。
                          </p>
                          <Button round color="danger"
                            href="/smartContract.html"
                            onClick={e => {}}
                          >
                            <Icon>exit_to_app</Icon> View App
                          </Button>
                        </CardBody>
                      </Card>
                    </GridItem>
                  </GridContainer>
                  ) },
                ]}
              />
              <div className={classes.tabSpace} />
            </GridItem>
          </GridContainer>
        </div>
      </div>
      {/* Project 1 END */}
      {/* Project 3 START
      <div
        className={`${classes.projects} ${classes.sectionDark} ${
          classes.projects3
        }`}
      >
        <div className={classes.container}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={8}
              md={8}
              className={`${classes.mlAuto} ${classes.mrAuto} ${
                classes.textCenter
              }`}
            >
              <Muted>
                <h6>OUR WORK</h6>
              </Muted>
              <h2 className={classes.title}>
                Some of Our Awesome Products - 3
              </h2>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={5} md={5} className={classes.mlAuto}>
              <Card plain className={classes.card2}>
                <a href="#pablo" onClick={e => e.preventDefault()}>
                  <CardHeader plain image>
                    <img src={cardProject1} alt="..." />
                  </CardHeader>
                </a>
                <CardBody>
                  <h6 className={classes.cardCategory}>WEB DESIGN</h6>
                  <a href="#pablo" onClick={e => e.preventDefault()}>
                    <h4 className={classes.cardTitle}>
                      Famous Website Redesign
                    </h4>
                  </a>
                  <p className={classes.cardDescription}>
                    Don't be scared of the truth because we need to restart the
                    human foundation in truth.
                  </p>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={5} md={5} className={classes.mrAuto}>
              <Card plain className={classes.card2}>
                <a href="#pablo" onClick={e => e.preventDefault()}>
                  <CardHeader plain image>
                    <img src={cardProject2} alt="..." />
                  </CardHeader>
                </a>
                <CardBody>
                  <h6 className={classes.cardCategory}>PRODUCTIVITY TOOLS</h6>
                  <a href="#pablo" onClick={e => e.preventDefault()}>
                    <h4 className={classes.cardTitle}>
                      Beautiful Desktop for Designers
                    </h4>
                  </a>
                  <p className={classes.cardDescription}>
                    Don't be scared of the truth because we need to restart the
                    human foundation in truth.
                  </p>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={5} md={5} className={classes.mlAuto}>
              <Card plain className={classes.card2}>
                <a href="#pablo" onClick={e => e.preventDefault()}>
                  <CardHeader plain image>
                    <img src={cardProject3} alt="..." />
                  </CardHeader>
                </a>
                <CardBody>
                  <h6 className={classes.cardCategory}>ANDROID APP</h6>
                  <a href="#pablo" onClick={e => e.preventDefault()}>
                    <h4 className={classes.cardTitle}>Analytics for Android</h4>
                  </a>
                  <p className={classes.cardDescription}>
                    Don't be scared of the truth because we need to restart the
                    human foundation in truth.
                  </p>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={5} md={5} className={classes.mrAuto}>
              <Card plain className={classes.card2}>
                <a href="#pablo" onClick={e => e.preventDefault()}>
                  <CardHeader plain image>
                    <img src={cardProject4} alt="..." />
                  </CardHeader>
                </a>
                <CardBody>
                  <h6 className={classes.cardCategory}>WEBSITE</h6>
                  <a href="#pablo" onClick={e => e.preventDefault()}>
                    <h4 className={classes.cardTitle}>Behance Redesign</h4>
                  </a>
                  <p className={classes.cardDescription}>
                    Don't be scared of the truth because we need to restart the
                    human foundation in truth.
                  </p>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div> */}
      {/* Project 3 END */}
      {/* Project 4 START
      <div className={`${classes.projects} ${classes.projects4}`}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={8}
              md={8}
              className={`${classes.mlAuto} ${classes.mrAuto} ${
                classes.textCenter
              }`}
            >
              <h2 className={classes.title}>
                Some of Our Awesome Products - 4
              </h2>
              <h5 className={classes.description}>
                This is the paragraph where you can write more details about
                your projects. Keep you user engaged by providing meaningful
                information.
              </h5>
              <div className={classes.sectionSpace} />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={5} md={5} className={classes.mlAuto}>
              <Card
                background
                className={classes.card4}
                style={{ backgroundImage: `url(${cardProject2})` }}
              >
                <CardBody background className={classes.cardBody4}>
                  <Badge color="rose">Client: Apple</Badge>
                  <a href="#pablo" onClick={e => e.preventDefault}>
                    <h3 className={classes.cardTitle}>Beautiful Project</h3>
                    <p className={classes.cardDescription}>
                      Don't be scared of the truth because we need to restart
                      the human foundation in truth.
                    </p>
                  </a>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={5} md={5} className={classes.mrAuto}>
              <InfoArea
                className={classes.info4}
                title="Graphic Design"
                description="We've created the design of the website using modern Technologies like Sketch. It was a very interesting collaboration."
                icon={FormatPaint}
                iconColor="info"
              />
              <InfoArea
                className={classes.info4}
                title="Fully Coded in HTML5"
                description="We've developed the website with HTML5 and CSS3. The client has access to the code using GitHub."
                icon={Code}
                iconColor="primary"
              />
              <InfoArea
                className={classes.info4}
                title="CMS Admin Dashboard"
                description="There is also a Fully Customizable CMS Admin Dashboard for this product."
                icon={Dashboard}
                iconColor="danger"
              />
            </GridItem>
          </GridContainer>
          <hr />
          <GridContainer>
            <GridItem xs={12} sm={5} md={5} className={classes.mlAuto}>
              <InfoArea
                className={classes.info4}
                title="Marketing"
                description="We've created the marketing campaign of the website. It was a very interesting collaboration."
                icon={Timeline}
                iconColor="rose"
              />
              <InfoArea
                className={classes.info4}
                title="Fully Coded in HTML5"
                description="We've developed the website with HTML5 and CSS3. The client has access to the code using GitHub."
                icon={Code}
                iconColor="success"
              />
              <InfoArea
                className={classes.info4}
                title="Built Audience"
                description="There is also a Fully Customizable CMS Admin Dashboard for this product."
                icon={Group}
                iconColor="info"
              />
            </GridItem>
            <GridItem xs={12} sm={5} md={5} className={classes.mrAuto}>
              <Card
                background
                className={classes.card4}
                style={{ backgroundImage: `url(${cardProject5})` }}
              >
                <CardBody background className={classes.cardBody4}>
                  <Badge color="rose">CLIENT: DJ KHALED</Badge>
                  <a href="#pablo" onClick={e => e.preventDefault}>
                    <h3 className={classes.cardTitle}>Another One</h3>
                    <p className={classes.cardDescription}>
                      Don't be scared of the truth because we need to restart
                      the human foundation in truth.
                    </p>
                  </a>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div> */}
      {/* Project 4 END */}
    </div>
  );
}

export default withStyles(projectsStyle)(SectionProjects);



// WEBPACK FOOTER //
// ./src/views/SectionsPage/Sections/SectionProjects.jsx